import styled, { css } from 'styled-components';
import { ContainerSt } from 'app/shared/ui';

import { media, color } from '../../styles_js/variables';

export const ErrorPageContainerSt = styled(ContainerSt)`
  width: 100%;
  padding: 152px 0;
  padding-bottom: 192px;
`;

export const ErrorPageSt = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 24px;
  max-width: 768px;
  margin: 0 auto;

  ${media.md(css`
    padding: 0;
  `)};

  span {
    font-size: 16px;
    line-height: 2;
    color: ${color.brandSecondaryLight};
    text-align: center;
    margin-bottom: 56px;
  }
`;

export const ErrorImageSt = styled.img`
  display: block;
  max-width: 156px;
  margin-right: auto;
  margin-left: auto;
`;

export const TitleSt = styled.h2`
  font-size: 40px;
  font-weight: bold;
  line-height: 1.4;
  margin: 80px 0 40px 0;
  text-align: center;
`;
